import { Panel } from '../panel.class';

export const isFrontPanelCfn = (panel: Panel, frontPanelId: string | null): boolean => {
	if (frontPanelId === null) return false;

	// a back panel is never connnected to a front panel
	return panel.id === frontPanelId;
};
